<template>
  <div id="app">
    <div  v-if="load_show">
      <load></load>
    </div>
    <div class="main">
      <el-card class="box-card leftcon left">
        <div class="left-con">
          <div class="pd" v-if="subject.judge_status">
            <div class="title">判 断</div>
            <div v-for="(item,key) in subject.list.judge.local" :key="'panduan1'+key" class="con" :id="'panduan1-'+key">
              <b>{{'第 ' + (key+1) + ' 题'}}</b>
              <div class="option">

                <p>{{item.name}}</p>
                <el-radio-group v-model="temp['local'][key]">
                  <el-radio label="1" @change="change('judge','local', key,'1')">正确</el-radio>
                  <el-radio label="0" @change="change('judge','local', key,'0')">错误</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div v-for="(item,key) in subject.list.judge.public" :key="'panduan2'+key" class="con" :id="'panduan2-'+key">
              <b>{{'第 ' +( subject.list.judge.local.length+key+1 )+ ' 题'}}</b>
              <div class="option">

                <p>{{item.name}}</p>
                <el-radio-group v-model="temp['public'][key]">
                  <el-radio label="1" @change="change('judge','public', key,'1')">正确</el-radio>
                  <el-radio label="0" @change="change('judge','public', key,'0')">错误</el-radio>


                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="xz" v-if="subject.select_status">
            <div class="title">选 择</div>
            <div v-for="(item,key) in subject.list.select.local" :key="'xuanze1'+key" class="con" :id="'xuanze1-'+key">
              <b>{{'第 ' + (key+1)+ ' 题 '+' ['+item.answer+'选]'}}</b>
              <div class="option">

                <p>{{item.name}}</p>

                       <el-checkbox  v-for="(i,key1) in item['choice']"  :key="key1" :label="i" style="width: 100%;" @change="change('select','local', key,key1)">
                         {{options[key1]}}.{{i}}
                 </el-checkbox>

              </div>
            </div>
            <div v-for="(item,key) in subject.list.select.public" :key="'xuanze2'+key" class="con"  :id="'xuanze2-'+key">
              <b>{{'第 ' + (subject.list.select.local.length+key+1)+ ' 题 '+' ['+item.answer+'选]'}}</b>
              <div class="option">
                <p>{{item.name}}</p>

                    <el-checkbox v-for="(i,key1) in item['choice']"  :key="key1" :label="i" style="width: 100%;" @change="change('select','public', key,key1)">
                         {{options[key1]}}.{{i}}
                    </el-checkbox>

              </div>
            </div>
          </div>
        </div>
      </el-card>


      <div class=" rightcon right">
        <el-card class="box-card">
          <div class="rightconhead">
            <div>答题卡</div>
            <time>{{timeText}}</time>
          </div>
          <div class="right-con">
            <div class="detail">
              <div class="detailleft">姓名</div>
              <div class="">：   {{info.rale_name}}</div>
              <div class="detailleft">卷面满分</div>
              <div class="">： 100分</div>

              <div class="detailleft">合格线</div>
              <div class="">：   {{score}}分</div>
              <div class="detailleft">答题时间</div>
              <div class="">：  {{exam_time}}分钟</div>
            </div>
            <div style=" max-height: calc( 100vh - 340px); overflow: auto;">
               <div class="title" style="margin-top: 0;">判 断</div>
              <div class="num" v-if="subject.judge_status">
                 <el-button type="primary" plain v-for="(item,key) in subject.list.judge.local" :key="'panduan11'+key"  :id="'judge_local_'+key"  @click="buttonitem('#panduan1-'+key)">{{key+1}}</el-button>
                 <el-button type="primary" plain v-for="(item,key) in subject.list.judge.public" :key="'panduan12'+key"  :id="'judge_public_'+key"  @click="buttonitem('#panduan2-'+key)">{{(subject.list.judge.local.length+key+1)}}</el-button>
              </div>
              <div class="title">选 择</div>
              <div class="num"  v-if="subject.select_status" >

                <el-button type="primary" plain   v-for="(item,key) in subject.list.select.local" :key="'xaunze11'+key"  :id="'select_local_'+key"  @click="buttonitem('#xuanze1-'+key)">{{key+1}}</el-button>
                <el-button type="primary" plain   v-for="(item,key) in subject.list.select.public" :key="'xuanzze12'+key" :id="'select_public_'+key"  @click="buttonitem('#xuanze2-'+key)">{{(subject.list.select.local.length+key+1)}}</el-button>
              </div>
            </div>

          </div>

        <el-button class="sub" type="primary" @click="submit()">交卷</el-button>
        </el-card>

      </div>



    </div>
    <!--电子签名-->
    <el-dialog title="电子签名" :visible.sync="autograph.show"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()">
      请输入您的密码: <el-input show-password v-model="autograph.input" style="margin: 1rem 0 1rem 0 ;"></el-input>
      <span >您触发的时间的: {{autograph.time}}</span>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autograph_click('ok')">确 认</el-button>
         <el-button  @click="autograph_click('on')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import load from '../../../components/load.vue';
  export default {
    name: 'App',
     props: {
        time: {
            type: Number,
            default: 0
        }
    },
    data() {
      return {
        load_show:false,
        submission_type:false,//防止试卷重复提交
         second: 60,//考试时间倒计时秒
         minute: 0,//考试时间倒计时分
        idcard_status:'',//是否存在签名
        timing_i: 1,
        autograph:{
          time:'',
          show:false,
          input:'',
          num:''
        },
        info:this.$store.state.info,
        isColor: false,
        timeInterval: null,
        timeText: '',
        showTime: this.time,
        exam_time:'',//考试时间
        score:'',//分数
        jiaojuantype:true,//只是显示一次
        radio: '',
        options: ['A', 'B', 'C', 'D','E','F','G','H','I'],
        plan:{
          num:this.$route.query.num,
          type:'subject',
        },
        subject:{
          list:[],
          judge_status:false,
          select_status:false,
        },
        temp:{
          local:[],
          public:[]
        },
      }
    },
   components: {
     load:load
   },
        beforeDestroy () {
        clearInterval(this.timeInterval)
    },
    mounted () {
       this.get_task_info();
        if (this.showTime >= 0) {
            this.timing()
        } else {
            this.countDown()
        }
    },
    methods: {
     autograph_click(type){
       let _this=this
       if(type=='ok'){
         if(_this.autograph.input.length==0){
           _this.$message.error('请输入密码')
           return false
         }
         _this.axios.post('/v2/user_task/task_idcard', {data:{'num':_this.plan.num,'input':_this.autograph.input}}).then(function(res) {
           if (res.status == '200') {
             if (res.data.code == '1') {
               _this.$message.success(res.data.msg)
               _this.autograph.show=false
               _this.clear_dstimers()
               _this.submitee()
             } else {
               _this.$message.error(res.data.msg)
             }
           } else {
             _this.$message.error('服务器内部错误')
           }
         }).catch(function(error) {
           _this.$message.error('服务器内部错误')
         });
       }else{
         if(_this.minute==0 && _this.second==0){
           return
         }
           _this.timing()
           _this.autograph.show=false
           _this.clear_dstimers()

       }

     },
     closeDialog(){
       this.autograph_click('')
     },
     clear_dstimers(){
       clearInterval( this.dstimers)
       this.dstimers=null
       this.autograph.time=''
       this.autograph.input=''
     },
        timing () {
          let _this=this
            _this.isColor = true
            clearInterval(_this.timeInterval)
            _this.timeInterval = setInterval(() => {
              _this.second--
              if(_this.second<0){
                _this.timing_i++
                _this.second=59
              }
              _this.minute=_this.exam_time-_this.timing_i
              if(_this.minute==3 && _this.second==0){
                 this.$message({
                          message: '考试时间还有三分钟，请抓紧时间',
                          type: 'warning'
                        });
              }
              if( _this.minute==0 && _this.second==0){
                _this.submit()
                clearInterval(_this.timeInterval)
              }
                _this.timeText = _this.minute + '分' + _this.second+ '秒'
            }, 1000)
        },
        get_task_info(){
        let _this=this;
        _this.axios.get('/v2/user_task/get_task_info',
        {params:{type:_this.plan.type,num:_this.plan.num}}
        ).then(function(res) {
         if(res.status == '200'){
            if(res.data.code=='1'){
            _this.subject.list=res.data.data
            _this.exam_time = res.data.data.exam_time;
            _this.idcard_status=res.data.data.idcard_status;
             _this.score = res.data.data.score;
            if(  res.data.data=="题库数量为空，请先添加题库"){
               alert(res.data.data)
               window.location.href=$router.go(-1)
            }else{
              if((res.data.data.judge.local.length+res.data.data.judge.public.length)>0){
              _this.subject.judge_status=true;
              _this.setxzitem('judge','public');
              _this.setxzitem('judge','local');
            }
            if((res.data.data.select.local.length+res.data.data.select.public.length)>0){
              _this.subject.select_status=true;
              _this.setxzitem('select','public');
              _this.setxzitem('select','local');
            }
            }


            }else{
              _this.$message.error('服务器内部错误')
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        })
      },
      setxzitem(type,val){
        let _this=this
        if(type=='select'){
          for(let i=0;i< _this.subject.list.select[val].length;i++){
            let temp= _this.subject.list.select[val][i]
            temp['choice']=temp['choice'].split('----')
            _this.subject.list.select[val][i]=temp
          }
        }else{
          for(let i=0;i< _this.subject.list.judge[val].length;i++){
            _this.subject.list.judge[val][i]['user_choice']=[]
          }
        }

      },
      change(type1,type2,key,key1){
        let _this=this
        if(!_this.subject.list[type1][type2][key].hasOwnProperty('user_choice')){
          _this.subject.list[type1][type2][key]['user_choice']=[]
        }
        if(type1=='select'){
          if( _this.subject.list[type1][type2][key]['user_choice'].indexOf(_this.options[key1])=='-1'){
            _this.subject.list[type1][type2][key]['user_choice'].push(_this.options[key1])
          }else{
            _this.subject.list[type1][type2][key]['user_choice'].splice( _this.subject.list[type1][type2][key]['user_choice'].indexOf(_this.options[key1]),1)
          }
        }else{
            _this.subject.list[type1][type2][key]['user_choice']=[]
            _this.subject.list[type1][type2][key]['user_choice'].push(key1)
        }
        if( _this.subject.list[type1][type2][key]['user_choice'].length==0){
          document.getElementById(type1+'_'+type2+'_'+key).style.backgroundColor="#8EE5EE"
        }else{
          document.getElementById(type1+'_'+type2+'_'+key).style.backgroundColor="#00FF00"
        }
      },
      buttonitem(selector){
          var anchor = this.$el.querySelector(selector)
         document.documentElement.scrollTop =anchor.offsetTop
      },
      //有无签名判断
      submit(){
         let _this=this
             clearInterval(_this.timeInterval)
             if(_this.idcard_status==1){
               _this.autograph.num=_this.info.serial_number
               _this.count_down()
               _this.autograph.show=true
             }else{
               _this.submitee()
             }
      },
      count_down(){
        if(!this.dstimers){
          this.dstimers= setInterval(() => {
          let yy = new Date().getFullYear();
          　　let mm = new Date().getMonth()+1;
          　　let dd = new Date().getDate();
          　　let hh = new Date().getHours();
          　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
          　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
          　　this.autograph.time = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
            return;
          }, 1000);
        }

      },
      //试卷提交
      submitee(){
        let _this=this
        _this.load_show=true
          _this.subject.list.plan=_this.plan.num
          _this.axios.post('/v2/user_task/save_subject', {
            data: _this.subject.list //注意post请求发送参数的方式和get请求方式是有区别的
          }).then(function(res) {
            _this.load_show=false
            if(res.status=='200'){
              if(res.data.code=='1'){
                //做跳转到试卷结果参数：res.data.data
                  _this.$router.push({path:'/TasksubjeCtresult',query:{num:res.data.data}})
              }else{
                _this.$message.error(res.data.msg);
                _this.load_show=false
              }
            }else{
              _this.$message.error('服务器内部错误');
              _this.load_show=false
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误');
            _this.load_show=false
          });


      },
    }

  }
</script>

<style scoped>
  >>>.el-checkbox__label {
    display: inline;
  }

  >>>.el-checkbox, .el-checkbox__input {
    white-space: normal;
  }

  .main {
    min-height: calc(100vh - 40px);
    height: 100%;
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    position: relative;
    overflow: hidden;

  }

  /* 左侧 */
  .leftcon {
    width: calc(70% - 20px);
    padding: 0;
    background-color: white;
    min-height: calc(100vh - 40px);
    z-index: 1000;
    margin-bottom: 20px;
  }

  .left-con {
    padding: 20px;
    padding-top: 0;
  }

  .title {
    background-color: #f6f8ff;
    line-height: 50px;
    height: 50px;
    font-size: 18px;
    font-weight: 600;
    padding: 0 20px;
    margin-top: 20px;
  }

  .con {
    padding: 20px;
    margin: 3px 0;
    border: 1px solid gainsboro;
  }

  .option {
    padding-left: 20px;
  }

  .option>p {
    border-bottom: 1px solid gainsboro;
    padding: 5px;
    margin-top: 0;
  }

  /* 交卷 */
  >>>.sub {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }

  /* 右侧 */
  .rightcon {
    width: 20%;
    background-color: white;
    position: fixed;
    top: 20px;
    right: 15%;
  }
  >>>.el-card__body {
    padding: 0;
    margin-bottom: 20px;
  }

  .right-con {
    padding: 20px;
  }

  .rightconhead {
    overflow: auto;
  }

  .detail {
    background-color: #f6f8ff;
    margin-bottom: 20px;
    padding: 20px;
  }

  .detailleft {
    width: 80px;
    margin-right: 10px;
    float: left;
    text-align-last:justify;
text-align:justify;
text-justify:distribute-all-lines;
  }

  time {
    background-color: #409EFF;
    width: 50%;
    float: right;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #f50000;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .rightconhead>div {
    float: left;
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: 600;
    background-color: #f6f8ff;
  }

  .num {
    padding: 0 10px;
    border: 2px solid #f6f8ff;
    border-top: none;
    width: calc( 100% - 24px );
    box-shadow: 5px 5px 5px #f6f8ff;
  }

  .num>.el-button {
    text-align: center;
    padding: 10px 5px;
    margin: 10px 5px;
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Task/Tasksubject.vue